'use strict';

require('../../../modules/es.array.reverse');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');
module.exports = getBuiltInPrototypeMethod('Array', 'reverse');